module.exports = __webpack_public_path__ + "static/media/map2.9f1c69a5.svg";